import React from 'react';
import Icon from '../../../components/AppIcon';

const QualityAlerts = () => {
  const alerts = [
    {
      id: 1,
      type: 'critical',
      title: 'Patient Safety Alert',
      message: 'Complication rate for endodontic procedures exceeded threshold (5.2% vs 4.0% target)',
      timestamp: '15 minutes ago',
      action: 'Review Cases',
      icon: 'AlertTriangle'
    },
    {
      id: 2,
      type: 'warning',
      title: 'Quality Threshold Breach',
      message: 'Patient satisfaction score dropped below 4.5 for Dr. Thompson in oral surgery',
      timestamp: '2 hours ago',
      action: 'View Details',
      icon: 'AlertCircle'
    },
    {
      id: 3,
      type: 'info',
      title: 'Accreditation Reminder',
      message: 'Quality compliance report due in 7 days for regulatory submission',
      timestamp: '1 day ago',
      action: 'Generate Report',
      icon: 'FileText'
    }
  ];

  const getAlertStyles = (type) => {
    switch (type) {
      case 'critical':
        return {
          container: 'bg-error/10 border-error/30',
          icon: 'text-error',
          badge: 'bg-error text-error-foreground'
        };
      case 'warning':
        return {
          container: 'bg-warning/10 border-warning/30',
          icon: 'text-warning',
          badge: 'bg-warning text-warning-foreground'
        };
      case 'info':
        return {
          container: 'bg-primary/10 border-primary/30',
          icon: 'text-primary',
          badge: 'bg-primary text-primary-foreground'
        };
      default:
        return {
          container: 'bg-muted/50 border-border',
          icon: 'text-muted-foreground',
          badge: 'bg-muted text-muted-foreground'
        };
    }
  };

  return (
    <div className="bg-card rounded-xl border border-border shadow-elevation-2 p-4 md:p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-foreground flex items-center gap-2">
          <Icon name="Bell" size={20} className="text-primary" />
          Quality Alerts
          {alerts?.length > 0 && (
            <span className="ml-2 px-2 py-0.5 text-xs font-semibold bg-error text-error-foreground rounded-full">
              {alerts?.length}
            </span>
          )}
        </h2>
        <button className="text-sm text-primary hover:underline font-medium">
          View All
        </button>
      </div>

      <div className="space-y-3">
        {alerts?.map((alert) => {
          const styles = getAlertStyles(alert?.type);
          return (
            <div
              key={alert?.id}
              className={`rounded-lg border p-4 ${styles?.container} transition-all hover:shadow-md`}
            >
              <div className="flex items-start gap-3">
                <div className={`flex-shrink-0 ${styles?.icon}`}>
                  <Icon name={alert?.icon} size={20} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-start justify-between gap-2 mb-1">
                    <h3 className="text-sm font-semibold text-foreground">{alert?.title}</h3>
                    <span className={`px-2 py-0.5 text-xs font-medium rounded ${styles?.badge}`}>
                      {alert?.type?.toUpperCase()}
                    </span>
                  </div>
                  <p className="text-sm text-foreground mb-2">{alert?.message}</p>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-muted-foreground flex items-center gap-1">
                      <Icon name="Clock" size={12} />
                      {alert?.timestamp}
                    </span>
                    <button className="text-xs font-medium text-primary hover:underline">
                      {alert?.action} →
                    </button>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default QualityAlerts;